<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive" />
  </router-view>
</template>
<style>
body,
html,
#app {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
